module.exports = __webpack_public_path__ + "img/faq4.4ad97df2.png";